import { request } from './request';
import { catchError, EMPTY, map, of, startWith, switchMap } from 'rxjs';
import { convertToAsyncTaskState } from '../utils/rxjs/task';
import { bind } from '@react-rxjs/core';
import { driver$ } from './driver';
import { createSignal } from '@react-rxjs/utils';
import { queueNotice } from '../components/Notice';

export type TripType = 'NONE' | 'PRIVATE' | 'BUSINESS' | 'WORK';

export const getTripType = (objectId?: number) =>
  request<TripType | ''>(
    `/gateway/lcv-driver-service/v20220125/trip-type?objectId=${objectId ?? ''}`
  );

export const setDefaultTripType = (tripType: TripType) =>
  request<TripType>(
    `/gateway/driver-service/v20220121/default-trip-type?type=${tripType}`,
    { method: 'PUT' }
  );

export const [setTripType$, setTripType] = createSignal<TripType>();

export const tripType$ = setTripType$.pipe(
  switchMap((tripType) =>
    setDefaultTripType(tripType).pipe(
      catchError(() => {
        queueNotice({
          message: 'Trip.Type.Change.Error',
        });
        return EMPTY;
      })
    )
  ),
  startWith(null),
  switchMap(() =>
    driver$.pipe(
      map((driver) => driver?.assignation?.objectId),
      switchMap((objectId) =>
        getTripType(objectId).pipe(
          catchError(() => {
            queueNotice({
              message: 'Trip.Type.Get.Error',
            });
            return of(null);
          })
        )
      )
    )
  )
);

export const [useTripType] = bind(tripType$.pipe(convertToAsyncTaskState()), {
  result: null,
  running: true,
  error: null,
});
